/* eslint-disable no-template-curly-in-string */
export const ValidateMessages = {
  required: "${label}は必須項目です。",
  types: {
    email: "${label}は不正です。",
  },
};

export const Messages = {
  "ERR-001": "入力されたログイン情報が不正です。",
  "ERR-002": "登録されている情報が見つかりませんでした。",
  "ERR-003": "入力されたメールアドレスは既に登録されています。",
  "ERR-004":
    "同一機能において「閲覧」「編集」設定が不整合です。修正してください。",
  "ERR-005": "志願者情報が取り込まれているため、試験の削除は出来ません。",
  "ERR-006": "選定した条件の判定単位が存在しません。",
  "ERR-007": "アップロードするファイルの文字コードはShift_JISにしてください。",
  "ERR-008": "出力対象を選択してください。",
  "ERR-009":
    "新年度のデータとして一括登録する場合、更新区分は1:新規登録にしてください。",
  "ERR-010": "同一IDが含まれているため処理できません。",
  "ERR-011": "修正対象のデータが存在しません。",
  "ERR-012": "エラーが発生したため、マスタのインポートはキャンセルされました。",
  "ERR-013": "ログインアカウントが無効です。管理者に連絡してください。",
  "ERR-014": "新しいパスワードとパスワード確認が一致しません。",
  "ERR-015":
    "ログインアカウントがロックされました。パスワード変更を行ってください。",
  "ERR-016": "検索結果が多すぎます、条件を絞り込んでください。",
  "ERR-017": "入試年度は現在年度～現在年度+1までです。",
  "ERR-018": "CSVが保存できませんでした。",
  "ERR-019": "対象試験データが存在しません。",
  "ERR-020": "エラーが発生しました。問い合わせてください。",
  "ERR-021": "CSVファイルが指定されていません。",
  "ERR-022": "文字コードがShiftJISではありません。",
  "ERR-023": "データが存在しません。",
  "ERR-024": "ユーザアカウントにはメールアドレスを入力しないでください。",
  "ERR-025": "ユーザアカウントが既に登録されています。",
  "ERR-026": "1グループあたりの人数は最大10人です。",
  "ERR-027": "グループ数と１グループあたりの人数は同時に指定出来ません。",
  "ERR-028":
    "大変込み合っております。しばらく時間をあけてから実行してください。",
  "ERR-029": "アップロードフォルダを選択してください。",
  "ERR-030": "志願者の検索に失敗しました。",
  "ERR-031": "志願者のデータを検索してください。",
  "ERR-032": "グループ数は数字で入力してください。",
  "ERR-033": "グループあたりの人数を数字で入力してください。",
  "ERR-034": "グループNoの自動割り当てに失敗しました。",
  "ERR-035": "グループNoを指定していないデータがあります。",
  "ERR-036": "グループNoは数字で入力してください。",
  "ERR-037": "志願者面接グループの作成に失敗しました。",
  "ERR-038":
    "入力したパスワードは、パスワードポリシーの要件を満たしていません。",
  "ERR-039": "パスワードの変更に失敗しました。",
  "ERR-040": "パスワード再設定の有効期限が過ぎました。",
  "ERR-041": "を登録してください。",
  "ERR-042": "採点パターンタイプを選択してください。",
  "ERR-043": "は100文字以内に入力してください。",
  "ERR-044": "最高点は最低点より大きい数字で入力してください。",
  "ERR-045": "使用中のルーブリックを削除できません。",
  "ERR-046": "採点情報がありません。採点対象を再度確認してください。",
  "ERR-047": "採点結果の保存に失敗しました。",
  "ERR-048": "本人確認または欠席を選択してください。",
  "ERR-049": "採点開始できません。",
  "ERR-050": "総括コメントには100文字以内で入力してください。",
  "ERR-051": "必須項目です。",
  "ERR-052": "評価コメントには100文字以内で入力してください。",
  "ERR-053": "特記事項には100文字以内で入力してください。",
  "ERR-054": "提出済設定に失敗しました。",
  "ERR-055": "を設定してください。",
  "ERR-056": "既に同じ問題名が登録されています。変更してください。",
  "ERR-057": "グループ数または１グループあたりの人数を入力してください。",
  "ERR-058": "試験科目を登録してください。",
  "ERR-059": "採点対象の試験科目のルーブリックを指定してください。",
  "ERR-060": "試験のN次が試験科目のN次と一致しません。",
  "ERR-061": "次試験の試験科目が登録されていません。",
  "ERR-062": "選択された判定単位の試験が存在しているため、登録できません。",
  "ERR-063":
    "試験科目の採点対象人数(複数人)に対して、選択されたルーブリックに「1人用」が選択されました。",
  "ERR-064":
    "試験科目の採点対象人数(1人)に対して、選択されたルーブリックに「複数人用」が選択されました。",
  "ERR-065":
    "試験科目＝答案の場合、選択できるルーブリックの採点パターンは(1),(4),(6),(7),(9)です。",
  "ERR-066":
    "該当採点担当候補者が既に割り振られているため、再度指定できません。",
  "ERR-067": "この科目は合否判定済みのため、登録できません。",
  "ERR-068": "次試験の合否判定がされていないため、登録できません。",
  "ERR-069": "該当採点担当候補者が既に割り振られているため、除外できません。",
  "ERR-070": "グループNoに抜け番があります。",
  "ERR-071": "合否判定が行われているため、確定解除できません。",
  "ERR-072": "面接グループ内の確定値を全て入力してください。",
  "ERR-073": "確定値を入力してください。",
  "ERR-074": "確定する項目を選択してください。",
  "ERR-075": "面接グループ内の項目を全て選択してください。",
  "ERR-076": "使用中の問題を削除できません。",
  "ERR-077": "指定した問題が存在しません。",
  "ERR-078": "問題登録は失敗しました。",
  "ERR-079": "次試験の合否判定がされていないため、処理できません。",
  "ERR-080": "合否判定データは異常状態です。問い合わせてください。",
  "ERR-081":
    "合否結果CSV取込で合否判定されています。合否結果CSV取込を行ってください。",
  "ERR-082": "採点結果の中で、採点確定されていない志願者が存在しています。",
  "ERR-083": "既に合否判定が行われているため、処理できません。",
  "ERR-084":
    "合否判定データ取得時にエラーが発生しました。問い合わせてください。",
  "ERR-085": "合格とする合格点を入力してください。",
  "ERR-086": "合格とする合計点は必須項目です。",
  "ERR-087":
    "複数教員の採点結果(欠席入力)が不一致の志願者が存在しています。欠席入力不一致箇所を訂正してください。",
  "ERR-088": "過去年度のデータを更新できません。",
  "ERR-089": "志願者データが登録されている試験を削除できません。",
  "ERR-090": "は2000文字以内に入力してください。",
  "ERR-091":
    "処理中にステータスが変更になった箇所があります。再度処理をやり直してください。",
  "ERR-092":
    '採点担当者はスーパー修正は行えません。スーパー修正を"不可"に変更してください。',
  "ERR-093": "採点結果を先に表示してください。",

  "MSG-001": "パスワードを変更しました。",
  "MSG-002": "CSVアップロードが完了しました。",
  "MSG-003": "志願者面接グループを作成しました。",
  "MSG-004": "採点結果を保存しました。",
  "MSG-005": "面接時間超過",
  "MSG-006": "面接時間が制限より過ぎました。",
  "MSG-007": "担当受験生データがありません。",
  "MSG-008": "採点担当者を登録しました。",
  "MSG-009": "採点担当者同士の得点に乖離があります。",
  "MSG-010": "合否結果を保存しました。",
  "MSG-011": "合否結果を確定しました。",
  "MSG-012":
    "取込処理の実行を開始しました。[出願時提出書類登録結果確認]機能で処理結果を確認してください。",
  "MSG-013": "対象の採点が見つかりませんでした。",
  "MSG-014": "件、提出されました。",
  "MSG-015": "パスワードをリセットしました。",
  "MSG-016": "提出待ちの採点結果があります",
  "MSG-017": "提出待ちの採点結果が{0}件あります。",
  "MSG-018": "採点完了した採点結果を一括提出しました。",

  "CON-001": "本当に削除してよろしいですか？",
  "CON-002": "2次試験に登録されている試験科目が削除されてもよろしいですか？",
  "CON-003": "データを保存しないまま画面をクローズしてもよろしいですか？",
  "CON-004":
    "採点ステータスが「採点完了」の採点結果を全てステータス「提出済」に変更してよろしいですか？",
  "CON-005": "登録済グループを作成し直します。よろしいですか？",
  "CON-006":
    "グループを自動作成します。登録済グループがある場合、クリアされます。よろしいですか？",
  "CON-007":
    "採点パターンを変更した場合、登録済みの評価観点、評価観点詳細もクリアされます、よろしいですか？",
  "CON-008": "採点完了にしてもよろしいですか？",
  "CON-009": "採点結果を保存して採点完了状態にします。",
  "CON-010": "採点結果を保存してもよろしいですか？",
  "CON-011": "採点確定にしてもよろしいですか？",
  "CON-012": "採点結果を保存して確定状態にします。",
  "CON-013": "採点を開始します。対象者に間違えはないですか？",
  "CON-014": "採点修正が記録されます。よろしいですか？",
  "CON-015": "採点完了の採点結果を全て提出してもよろしいですか？",
  "CON-016": "提出済に設定した採点結果を修正できません。",
  "CON-017": "採点結果を保存しましたか？",
  "CON-018": "採点担当者を登録してもよろしいですか？",
  "CON-019": "採点ステータスを「提出済」に変更します。よろしいですか？",
  "CON-020":
    "採点ステータスを「提出済」から「採点完了」に変更します。よろしいですか？",
  "CON-021": "採点担当を解除します。採点結果が削除されますがよろしいですか？",
  "CON-022": "選択された項目の採点結果を一括確定します。よろしいですか？",
  "CON-023": "採点結果を確定します。よろしいですか？",
  "CON-024": "採点結果の確定を解除します。よろしいですか？",
  "CON-025": "問題を削除してもよろしいですか？",
  "CON-026": "合否判定が空欄の箇所は不合格を設定して保存しますか？",
  "CON-027": "入力内容がクリアされます。よろしいですか？",
  "CON-028": "保存してもよろしいですか？",
  "CON-029": "確定してもよろしいですか？確定後に合否の修正はできません。",
  "CON-030": "確定してもよろしいですか？",
  "CON-031": "登録してもよろしいですか？",
  "CON-032": "既に採点入力済です。担当者を変更しますか？",
  "CON-033": "既に採点入力済の担当者を変更しようとしています。よろしいですか？",
  "CON-034": "採点完了した採点結果を一括提出します。よろしいですか？",
};
